import { MutableRefObject, useEffect, useRef } from 'react';
import * as d3 from 'd3';

export const useD3 = (renderChartFn: any, dependencies: any): MutableRefObject<string | d3.BaseType | SVGSVGElement | undefined> => {
  const ref = useRef<string | d3.BaseType | SVGSVGElement> ();

  useEffect(() => {
    renderChartFn(d3.select(ref.current as any));
    return () => {};
  }, dependencies);
  return ref;
}
